<template>
    <div role="list">
		<data-loader ref="loaderElement" url="/v1/notifications" v-model:data="notifications" :params="params" on-scroll lazy @updated="handleLoadedNotifications">

			<template #loading>
				<notification-skeleton v-for="notificationLoader in params.limit" :key="'notification-loader-' + notificationLoader"/>
			</template>

			<notification v-for="(notification, index) in notifications" :key="'notification-' + index"
						  @delete="handleDeletedNotification(notification)"
						  :notification="notification"/>

			<template #missing>
				<div class="p-16 w-full">
					<lazy-missing-info no-spacing :text="$t('missing.notifications.index')"/>
				</div>
			</template>
		</data-loader>
    </div>
</template>

<script setup lang="ts">
import {useGlobalStore} from "../../store";
import {ref} from 'vue';
import type {Ref} from 'vue';
import type {DataLoader} from "#components";

const props = withDefaults(defineProps<{
	limit?: number
}>(), {
	limit: 10
});

const emit = defineEmits(['loaded']);

const {$apiFetch} = useNuxtApp();
const globalStore = useGlobalStore();

const notifications = ref([]);
const loaderElement: Ref<InstanceType<typeof DataLoader> | null> = ref(null);

const params = {
	limit: props.limit
};

function handleDeletedNotification(notification) {
	const index = notifications.value.indexOf(notification);

	// Delete at index
	if (index > -1) {
		notifications.value.splice(index, 1);
	}
}

function handleLoadedNotifications({data}) {
	globalStore.setUnreadNotificationsCount(0);

	const hasUnreadNotifications = data.some(notification => !notification.read_at);
	if (hasUnreadNotifications) {
		$apiFetch('/v1/notifications/read', {
			method: 'PUT'
		});
	}

	emit('loaded', data);
}

function reload() {
	if (loaderElement.value) {
		loaderElement.value.reload(1, false, false);
	}
}

defineExpose({
	reload
})
</script>